import React from "react";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Input, Space, Tooltip } from "antd";
import { useDispatch } from "react-redux";
import { setDefaultSupporterSearch } from "store/user/(default)/supporter/default_supporter.action";
import { useSupporterAdd } from "hook/supporters/useSupporter";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const SupporterAction = () => {
  // -------------------------- VAR -----------------------------
  const { handleOpenAdd } = useSupporterAdd();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  const handleChange = (e) => {
    const value = e.target.value;
    dispatch(setDefaultSupporterSearch(value));
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Space>
      <Input
        onChange={handleChange}
        style={{ minWidth: 250 }}
        placeholder="Tìm kiếm email nhân viên"
        suffix={<SearchOutlined style={{ color: "#aeaeae" }} />}
      />
      <Tooltip title="Thêm nhân viên mới">
        <Button onClick={handleOpenAdd} icon={<PlusOutlined />} />
      </Tooltip>
    </Space>
  );
};
export default SupporterAction;
